import en from './locale/en';

const localeLoaders = {
  ar: () => import('./locale/ar/index.js'),
  bg: () => import('./locale/bg/index.js'),
  ca: () => import('./locale/ca/index.js'),
  cs: () => import('./locale/cs/index.js'),
  da: () => import('./locale/da/index.js'),
  de: () => import('./locale/de/index.js'),
  el: () => import('./locale/el/index.js'),
  es: () => import('./locale/es/index.js'),
  fa: () => import('./locale/fa/index.js'),
  fi: () => import('./locale/fi/index.js'),
  fr: () => import('./locale/fr/index.js'),
  he: () => import('./locale/he/index.js'),
  hi: () => import('./locale/hi/index.js'),
  hu: () => import('./locale/hu/index.js'),
  id: () => import('./locale/id/index.js'),
  it: () => import('./locale/it/index.js'),
  ja: () => import('./locale/ja/index.js'),
  ko: () => import('./locale/ko/index.js'),
  lv: () => import('./locale/lv/index.js'),
  ml: () => import('./locale/ml/index.js'),
  nl: () => import('./locale/nl/index.js'),
  no: () => import('./locale/no/index.js'),
  pl: () => import('./locale/pl/index.js'),
  pt: () => import('./locale/pt/index.js'),
  pt_BR: () => import('./locale/pt_BR/index.js'),
  ro: () => import('./locale/ro/index.js'),
  ru: () => import('./locale/ru/index.js'),
  sk: () => import('./locale/sk/index.js'),
  sr: () => import('./locale/sr/index.js'),
  sv: () => import('./locale/sv/index.js'),
  ta: () => import('./locale/ta/index.js'),
  th: () => import('./locale/th/index.js'),
  tr: () => import('./locale/tr/index.js'),
  uk: () => import('./locale/uk/index.js'),
  vi: () => import('./locale/vi/index.js'),
  zh_CN: () => import('./locale/zh_CN/index.js'),
  zh_TW: () => import('./locale/zh_TW/index.js'),
  is: () => import('./locale/is/index.js'),
  lt: () => import('./locale/lt/index.js'),
};
const pendingLocales = new Map();

export const loadLocale = async (i18n, requestedLocale = 'en') => {
  const locale = requestedLocale.replace('-', '_');
  const loader = localeLoaders[locale];
  if (!loader || locale === 'en') return 'en';
  if (i18n.availableLocales.includes(locale)) return locale;

  if (!pendingLocales.has(locale)) {
    pendingLocales.set(
      locale,
      loader().finally(() => pendingLocales.delete(locale))
    );
  }
  const messages = await pendingLocales.get(locale);
  i18n.setLocaleMessage(locale, messages.default);
  return locale;
};

export default { en };
